/*
  Pause/Play control for autoplaying videos (WCAG 2.2.2 Pause, Stop, Hide).
  Markup: snippets/video-pause-toggle.liquid. Each button points at its video
  through aria-controls. A video paused by the visitor gets data-user-paused,
  so scripts that autoplay on scroll (initAutoplayVideos in global.js) leave it paused.
*/
(function() {
  if (window.videoPauseToggleLoaded) return;
  window.videoPauseToggleLoaded = true;

  function getVideo(button) {
    var id = button.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function setState(button, paused) {
    button.setAttribute('data-state', paused ? 'paused' : 'playing');
    button.setAttribute(
      'aria-label',
      paused ? button.getAttribute('data-label-play') : button.getAttribute('data-label-pause')
    );
  }

  function syncButtons(container) {
    (container || document).querySelectorAll('.video-pause-toggle[aria-controls]').forEach(function(button) {
      var video = getVideo(button);
      if (video) setState(button, video.paused);
    });
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('.video-pause-toggle[aria-controls]');
    if (!button) return;
    var video = getVideo(button);
    if (!video) return;
    event.preventDefault();

    if (video.paused) {
      video.removeAttribute('data-user-paused');
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function() {});
    } else {
      video.setAttribute('data-user-paused', '');
      video.pause();
    }
  });

  // Media events don't bubble, so listen in the capture phase to keep every
  // button in sync, including ones added later by the theme editor.
  ['play', 'pause'].forEach(function(type) {
    document.addEventListener(type, function(event) {
      var video = event.target;
      if (!video || video.tagName !== 'VIDEO' || !video.id) return;
      document.querySelectorAll('.video-pause-toggle[aria-controls="' + video.id + '"]').forEach(function(button) {
        setState(button, type === 'pause');
      });
    }, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { syncButtons(); });
  } else {
    syncButtons();
  }

  document.addEventListener('shopify:section:load', function(event) {
    syncButtons(event.target);
  });
})();
